export enum OfferType {
  PLAYER = 'player',
  COACH = 'coach'
}

export const OfferTypeTranslation = {
  [OfferType.PLAYER]: 'enum.offerType.player',
  [OfferType.COACH]: 'enum.offerType.coach'
};

export const OfferTypeListTranslation = {
  [OfferType.PLAYER]: 'Zawodnik',
  [OfferType.COACH]: 'Trener'
};
